import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { DialogConfirmtComponent } from "../components/dialogs/confirm/dialog-confirm.component";
import { MatDialog } from "@angular/material";

@Injectable()
export class ConfirmDialogService {
  constructor(private dialog: MatDialog) {}

  confirm(
    title: string,
    content: string,
    okButton?: string,
    noOkButton?: string,
    isAlert: boolean = false,
    blockOkButton: boolean = false,
    disableClose: boolean = false
  ): Observable<boolean> {
    if (!okButton) {
      okButton = "Sí";
    }

    if (!noOkButton) {
      noOkButton = "No";
    }

    const dialogRef = this.dialog.open(DialogConfirmtComponent, {
      width: "500px",
      disableClose: disableClose,
      data: {
        Title: title,
        Content: content,
        OkButtonText: okButton,
        NoOkButtonText: noOkButton,
        IsAlert: isAlert,
        BlockOkButton: blockOkButton
      },
    });

    return dialogRef.afterClosed();
  }
}

export interface IConfirmDialogData {
  Title: string;
  Content: string;
  IsAlert: boolean;
  OkButtonText: string;
  NoOkButtonText: string;
  BlockOkButton: boolean;
}
